import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from "react";
import "./icon-button.css";

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Required for screen readers — icon-only control. */
  "aria-label": string;
  variant?: "ghost" | "primary-fill";
  children: ReactNode;
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { variant = "ghost", className, type, children, ...rest },
  ref,
) {
  const classes = ["wp-iconbtn", `wp-iconbtn--${variant}`, className]
    .filter(Boolean)
    .join(" ");
  return (
    <button ref={ref} type={type ?? "button"} className={classes} {...rest}>
      <span aria-hidden="true" className="wp-iconbtn__glyph">
        {children}
      </span>
    </button>
  );
});
